import { useAct } from 'FlowBuilder/store'
import useGenericTranslate from './useGenericTranslateFlow';
import { QuestionTranslatableKeys, questionTranslatables } from 'FlowBuilder/lib/questionTranslatable';

export default function useQuestionTranslate<T extends string | number | symbol = QuestionTranslatableKeys>({ questionId = null, questionOverride = null, languageOverride = null } = {}) {
  const act = useAct();
  const { textContent } = useSel(s => questionOverride || s.questions.entities[questionId] || {})

  const {language, translated, fallback, flag} = useGenericTranslate<T>({ textContent, languageOverride, translatableConfiguration: questionTranslatables })

  function textContentUpdater(key: T, value: string) {
    if (questionOverride) {
      throw new Error("Cannot update text content when question is overridden");
    }
    act.questions.updateQuestionTextContent({questionId, language, key, value})
  }
  
  return {
    language,
    translated,
    fallback,
    textContentUpdater,
    flag
  }
}

